<template>
<div class="w-4/5 mx-auto">
    <div>
        <h1 class="text-2xl">{{ __('Bonjour') }}, {{ __($page.props.auth.user.civilite) }} {{ __($page.props.auth.user.prenom) }} {{ __($page.props.auth.user.nom) }}</h1>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        <inertia-link :href="route('utilisateur.commandes')" class="rounded-sm m-8 transition bg-white duration-500 shadow-lg p-2 sm:p-10 text-center hover:bg-cavilam-primary text-cavilam-primary hover:text-white">
            <div class="py-4 overflow-hidden">
                <div class="space-y-10">
                    <i class="fa fa-history" style="font-size:48px;"></i>
                    <div class="px-6 py-4">
                        <div class="space-y-5">
                            <div class="font-bold text-xl mb-2">{{ __('Commandes') }}</div>
                            <p class="text-base">
                                {{ __('voir_mes_commandes') }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </inertia-link>
        <inertia-link :href="route('utilisateur.editer.mot_de_passe')" class="rounded-sm m-8 transition bg-white duration-500 shadow-lg p-2 sm:p-10 text-center hover:bg-cavilam-primary text-cavilam-primary hover:text-white">
            <div class="py-4 overflow-hidden">
                <div class="space-y-10">
                    <i class="fa fa-shield-alt" style="font-size:48px;"></i>
                    <div class="px-6 py-4">
                        <div class="space-y-5">
                            <div class="font-bold text-xl mb-2">{{ __('Securite') }}</div>
                            <p class="text-base">
                                {{ __('Modifier_mon_mot_de_passe') }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </inertia-link>
        <inertia-link :href="route('inscription')" class="rounded-sm m-8 transition bg-white duration-500 shadow-lg p-2 sm:p-10 text-center hover:bg-cavilam-primary text-cavilam-primary hover:text-white">
            <div class="py-4 overflow-hidden">
                <div class="space-y-10">
                    <i class="fa fa-store" style="font-size:48px;"></i>
                    <div class="px-6 py-4">
                        <div class="space-y-5">
                            <div class="font-bold text-xl mb-2">{{ __('Boutique') }}</div>
                            <p class="text-base">
                                {{ __('Reserver_une_date') }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </inertia-link>
        <inertia-link :href="route('utilisateur.editer.donnees')"
              class="rounded-sm m-8 transition bg-white duration-500 shadow-lg p-2 sm:p-10 text-center hover:bg-cavilam-primary text-cavilam-primary hover:text-white">
            <div class="py-4 overflow-hidden">
                <div class="space-y-10">
                    <i class="fa fa-id-card" style="font-size:48px;"></i>
                    <div class="px-6 py-4">
                        <div class="space-y-5">
                            <div class="font-bold text-xl mb-2">{{ __('donnees') }}</div>
                            <p class="text-base">
                                {{ __('modifier_mes_infos_perso') }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </inertia-link>
    </div>
</div>
</template>

<script>
import App from "@/Layouts/App";

export default {
    layout: App,
    name: "Index"
}
</script>

<style scoped>

</style>
